export const ACTION_SWITCH_LEFT_MENU = 'ACTION_SWITCH_LEFT_MENU';
